import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {ApiService} from '../base/repository/api.service';
import {FileUrlItemResponse} from './entities/file-url-item-response';
import {ItemCreatedResponse} from '../base/entities/item-created-response';
import {GeneratedHistoryReportStatus, GeneratedHistoryReportStatusResponse} from './entities/history-report-status-response';
import {Upload} from '../upload-repository/entities/upload';
import {HistoryReportItemResponse} from './entities/history-report-item-response';
import {HistoryReportCollectionResponse} from './entities/history-report-collection-response';

@Injectable({
  providedIn: 'root'
})
export class FilesRepositoryService {

  constructor(private api: ApiService) {
  }

  getUrl(fileType: string, fileId: number, patientId: number): Observable<string> {
    return this.api.get<FileUrlItemResponse>('documents/generate-url', {fileType: fileType, fileId: fileId, patientId: patientId})
      .pipe(map(response => this.api.baseUrl + '/' + response.value));
  }

  enqueueGeneratedReport(patientId: number): Observable<number> {
    return this.api.post<ItemCreatedResponse>('documents/generate-history/enqueue', {patientId: patientId})
      .pipe(map(response => response.value));
  }

  getEnqueuedGeneratedReportStatus(id: number): Observable<GeneratedHistoryReportStatus> {
    return this.api.get<GeneratedHistoryReportStatusResponse>('documents/generate-history/status/' + id)
      .pipe(map(response => response.value));
  }

  getEnqueuedGeneratedReport(id: number): Observable<Upload> {
    return this.api.get<HistoryReportItemResponse>('documents/generate-history/' + id)
      .pipe(map(response => response.value));
  }
  getEnqueuedGeneratedReports(patientId: number): Observable<Upload[]> {
    return this.api.get<HistoryReportCollectionResponse>('documents/generate-history/reports/' + patientId)
      .pipe(map(response => response.items));
  }
}
